export default "__VITE_ASSET__BXtegxGW__"